module.exports = __webpack_public_path__ + "static/095_zakopianka_anagl-0e393f2411df9fd255ac59188c41f76b.jpg";